<div id="nav-loading">
  <div id="nav-loading-background"></div>
  <div id="nav-loading-message">
    <img src="assets/imgs/logo.png" />
  </div>
</div>
